// @ts-nocheck

import { createSelector } from 'reselect';

import { type Selector } from '../../../../types/selectors';
import { selectBoomGlobalMaxWinningAmount } from '../../selectors/global/globalPrimary.selector';
import { selectBoomUserProgressAllIsCompleted, selectBoomUserTotalWinnings } from '../../selectors/user.selector';

type BoomHeaderPropsType = {
  totalWon: number;
  isCompleted: boolean;
  maxWinnings?: number;
};

const selectBoomHeaderProps: Selector<BoomHeaderPropsType> = createSelector(
  [selectBoomUserTotalWinnings, selectBoomUserProgressAllIsCompleted, selectBoomGlobalMaxWinningAmount],
  (totalWon, isCompleted, maxWinnings) => ({ totalWon, isCompleted, maxWinnings }),
);

export default selectBoomHeaderProps;
